import { helpRequest, CancelToken } from 'helpers/api';
import { ROOT } from '../pages/HelpCenter/constants';

/**
 * Get list of collections from helpscout
 * @returns Promise
 */
export const getCollections = () => helpRequest.get('/collections');
/**
 * Get specific collection
 * @returns Promise
 */
export const getCollectionById = (id) => helpRequest.get(`/collections/${id}`);
/**
 * Get list of categories from helpscout
 * @returns Promise
 */
export const getCategories = (id) =>
  helpRequest.get(`/collections/${id}/categories`);

/**
 * Get full list of articles of specific collection
 * @param {object} collection
 * @param {integer} index
 * @param {array} collections
 * @returns Promise
 */
export const getCollectionFullArticles = (collection, index, collections) =>
  helpRequest.get(`collections/${collection.id}/articles`, {
    params: { sort: 'number', order: 'asc' },
  });

/**
 * Get list of articles related to selected
 * @param {string} articleId
 * @returns Promise
 */
export const getRelatedArticles = (articleId) =>
  helpRequest.get(`articles/${articleId}/related`);

/**
 * Get specific article
 * @param {string} articleId
 * @returns Promise
 */
export const getArticle = (articleId) =>
  helpRequest.get(`articles/${articleId}`);

/**
 * Get full list of articles of specific category
 * @param {string} categoryId
 * @returns Promise
 */
export const getArticles = (categoryId) =>
  helpRequest.get(`categories/${categoryId}/articles`);

/**
 * Get full list of articles of specific collection
 * @param {string} categoryId
 * @returns Promise
 */
// export const getArticles = collectionId =>
//     helpRequest.get(`collections/${collectionId}/articles`);

export let cancelSearchArticle;

/**
 * Get full list of articles of specific category
 * @param {string} input
 * @returns Promise
 */
export const searchArticle = (input, options) =>
  helpRequest.get(`search/articles`, {
    ...options,
    params: { query: input },
    cancelToken: new CancelToken((c) => {
      cancelSearchArticle = c;
    }),
  });

/**
 * Get collection
 * @param {string} collectionId
 * @returns Promise
 */
export const getCollection = (collectionId) =>
  helpRequest.get(`collections/${collectionId}`);

/**
 * Get category
 * @param {string} categoryId
 * @returns Promise
 */
export const getCategory = (categoryId) =>
  helpRequest.get(`categories/${categoryId}`);

export const getPublished = (array = []) => array.filter(({ status }) => status === 'published');

export const getLink = (collectionSlug, slug) =>
  `${ROOT}/${collectionSlug.split('icon')[0]}/${slug}`;
